import clsx from 'clsx';
import type * as React from 'react';

import { LoadingIndicator } from './LoadingIndicator';

export type LoadingIndicatorSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';

export interface LoadingPanelProps extends React.ComponentPropsWithoutRef<'div'> {
    /**
     * Size of the loading panel.
     */
    size?: LoadingIndicatorSize;
}

/**
 * Centered loading spinner.
 */
export function LoadingPanel(props: LoadingPanelProps): React.ReactElement {
    const { size = 'medium', ...rest } = props;

    return (
        <div
            {...rest}
            className={clsx(
                'flex min-w-56 flex-1 items-center justify-center bg-base',
                {
                    xsmall: 'min-h-56 px-1 py-2',
                    small: 'min-h-40 px-2 py-4',
                    medium: 'min-h-44 px-4 py-6',
                    large: 'min-h-44 px-4 py-6',
                    xlarge: 'min-h-64 px-4 py-10',
                }[size],
                rest.className
            )}
        >
            <LoadingIndicator size={size} />
        </div>
    );
}
